export const styles = {
  cellRoot: {
    borderBottom: 'none',
    fontSize: '14px',
    color: '#67727C',
  },
  cellTooltipIcon: {
    margin: '0 0 .27rem .2rem',
  },
  cellRootStatus: {
    borderBottom: 'none',
    paddingLeft: '1rem',
  },
  cellHeader: {
    color: '#354052',
    borderBottom: 'none',
    fontSize: '14px',
    textAlign: 'left',
  },
  previewButton: {
    height: '30px',
    minHeight: '30px',
    width: '60px',
    minWidth: '60px',
  },
  tooltip: {
    maxWidth: '150px',
    textAlign: 'center',
    fontSize: '12px',
  },
  pendingChip: {
    height: '28px',
    backgroundColor: '#FCE9B8',
    color: '#67727C',
    fontSize: '14px',
    fontWeight: 500,
  },
  pendingChipIcon: {
    height: '20px',
    color: '#F5A623',
  },
  completedChip: {
    height: '28px',
    backgroundColor: '#D6F5E3',
    color: '#67727C',
    fontSize: '14px',
    fontWeight: 500,
  },
  completedChipIcon: {
    height: '20px',
    color: '#00C853',
  },
  statusCellContent: {
    display: 'flex',
    alignItems: 'center',
  },
  actionCellContent: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  actionMenuWrapper: {
    alignSelf: 'center',
  },
  contextMenuButton: {
    minHeight: '1.5rem',
    maxHeight: '1.5rem',
    minWidth: '0.5rem',
    maxWidth: '0.5rem',
    padding: '0px 8px 0px 8px',
  },
  contextMenuIcon: {
    height: '1em',
  },
};
